import type { InterventionTemplateLinkProps } from "./intervention-template-link.type";

import { useAuthorization } from "@/modules/authorization";
import { ModelLink } from "@/modules/model-link";

import { InterventionTemplateLinkContent } from "./intervention-template-link.component";

export const InterventionTemplateLinkWrapper = (
  props: InterventionTemplateLinkProps
) => {
  const { canCreateModel } = useAuthorization();

  if (!canCreateModel("interventiontemplate")) {
    return <InterventionTemplateLinkContent {...props} />;
  }

  return (
    <ModelLink model="interventiontemplate" item={props.template}>
      <InterventionTemplateLinkContent {...props} />
    </ModelLink>
  );
};
